import { useCallback } from 'react';

import { TimeTracking } from '@work4all/models/lib/Classes/TimeTracking.entity';

import { settings, useSetting } from '../settings';

export const useTimeTrackingTemplates = () => {
  const setting = useSetting(settings.timeTrackingTemplates());

  const add = useCallback(
    (data: TimeTracking) => {
      setting.set([
        ...setting.value,
        {
          id: data.id,
          project: data.project,
          projectProcess: data.projectProcess,
          customer: data.customer,
          contract: data.contract,
          position: data.position,
          ticket: data.ticket,
          activityArticle: data.activityArticle,
          comment: data.comment,
        },
      ]);
    },
    [setting]
  );

  const remove = useCallback(
    (id: number) => {
      setting.set(setting.value.filter((template) => template.id !== id));
    },
    [setting]
  );

  const includes = useCallback(
    (id: number) => {
      return setting.value.some((template) => template.id === id);
    },
    [setting]
  );

  return { list: setting.value, add, remove, includes };
};
